export var get = function (key) {
    var _a, _b;
    return ((_b = (_a = document.cookie
        .split(';')
        .find(function (cookie) { return cookie.trim().startsWith("".concat(key, "=")); })) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.substring(key.length + 1)) || '';
};
